const { same } = require('../utils');

exports.computeHasBandedColumnsFromTables = tables => same(tables, 'hasBandedColumns', false);
